import './VideoThankYouMessage.css';
import React, { useEffect, useRef, useState } from 'react';
import { get, getGlobalDictionaryTerm } from '../../../utils';
import LazyPicture from '../../atoms/LazyPicture';
import { Placeholder, RichText } from '@sitecore-jss/sitecore-jss-react';
import { LOCAL_STORAGE_KEY_VIDEO_COLLECTION_DATA } from '../constants';
import Recaptcha from '../../Login/components/Recaptcha';
import RouterLink from '../../atoms/RouterLink';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
import { getUserCookie } from '../../Login/user_session';
const VideoThankYouMessage = _ref => {
  let {
    fields,
    rendering,
    hideModal,
    mapDictionary,
    removeFromLocalStorage,
    setCurrentStep,
    userProfile,
    sitecoreContext,
    collectedData,
    resetData,
    rtl,
    analytics,
    params
  } = _ref;
  const title = get(fields, 'data.configuration.thankYouTitle.jss.value', "");
  const description = get(fields, 'data.configuration.thankYouSubtitle.jss.value', "");
  const imageIcon = get(fields, 'data.configuration.thankYouIcon.jss.value.src', "");
  const imageIconAlt = get(fields, 'data.configuration.thankYouIcon.jss.value.alt', "");
  const iconCode = get(fields, 'data.configuration.thankYouIconCode.jss.value', "");
  const mainTitle = get(fields, 'data.configuration.thankYouTitleText.jss.value', "");
  const mainText = get(fields, 'data.configuration.thankYouText.jss.value', "");
  const thankYouImages = get(fields, 'data.configuration.thankYouImages.targetItems', []);
  const mainFirstImage = thankYouImages[0] ? thankYouImages[0].url : null;
  const mainSecondImage = thankYouImages[1] ? thankYouImages[1].url : null;
  const mainFirstImageAlt = thankYouImages[0] ? thankYouImages[0].name : '';
  const mainSecondImageAlt = thankYouImages[1] ? thankYouImages[1].name : '';
  const thankYouGenerateScriptLabel = get(fields, 'data.configuration.thankYouGenerateScriptLabel.jss.value', "");
  const thankYouGenerateScriptLink = get(fields, 'data.configuration.thankYouGenerateScriptLink.jss.value.href');
  const thankYouBackToStoryLabel = get(fields, 'data.configuration.thankYouBackToStoryLabel.jss.value', "");
  const thankYouBackToStoryLink = get(fields, 'data.configuration.thankYouBackToStoryLink.jss.value.href', "");
  const eventDefinitionKey = get(fields, 'data.configuration.salesforceFormKey.jss.value');
  const apiUrl = get(fields, 'data.configuration.apiUrl.jss.value');
  const formName = get(fields, 'data.configuration.formName.jss.value');
  const recaptchErrorMessage = getGlobalDictionaryTerm(sitecoreContext, 'FieldErrorRequiredRecaptcha') || '';
  const language = sitecoreContext.language || '';
  const recaptchaRef = useRef(null);
  const [mainTextReplaced, setMainTextReplaced] = useState('');
  const [recaptchaError, setRecaptchaError] = React.useState('');
  const [errorMessage, setErrorMessage] = React.useState('');
  const [generateScriptLink, setGenerateScriptLink] = React.useState(thankYouGenerateScriptLink);
  const [backToStoryLink, setBackToStoryLink] = React.useState(thankYouBackToStoryLink);
  const cookie = getUserCookie();
  const replacePlaceholders = () => {
    let result = mainText;
    if (mainText.includes('$firsname$')) {
      result = result.replace(/\$firsname\$/g, `<span>${userProfile.firstName || ''}</span>`);
    }
    if (mainText.includes('$lastname$')) {
      result = result.replace(/\$lastname\$/g, `<span>${userProfile.lastName || ''}</span>`);
    }
    setMainTextReplaced({
      value: result
    });
  };
  const sendForm = async () => {
    let myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${cookie.access_token}`);
    myHeaders.append('Content-Type', 'application/json');
    let recaptchaToken;
    if (recaptchaRef.current) {
      recaptchaToken = await recaptchaRef.current.getRecaptchaToken();
    }
    if (!recaptchaToken) {
      setRecaptchaError(recaptchErrorMessage);
    } else {
      setRecaptchaError('');
    }
    const getData = () => {
      const localStorageCollectionData = localStorage.getItem(LOCAL_STORAGE_KEY_VIDEO_COLLECTION_DATA);
      if (localStorageCollectionData) {
        return JSON.parse(localStorageCollectionData);
      }
      return collectedData;
    };
    const dataToSalesforce = {
      Url: window.location.href,
      EventDefinitionKey: eventDefinitionKey,
      Code: getData(),
      Language: language,
      FormName: formName,
      'g-recaptcha-response': recaptchaToken
    };
    await fetch(apiUrl, {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify(dataToSalesforce)
    }).then(async res => {
      if (!res.ok) {
        throw new Error(`HTTP error! Status: ${res.status}`);
      }
      const responseData = await res.json();
      if (responseData.result === true) {
        console.log('Success:', responseData);
      } else {
        // 'limit_reached' - 3 video limit per day is reached
        // 'user_not_found' - Unable to identify a user
        // 'video_failed' - An error occurred in 3rd party video generation service
        setErrorMessage(mapDictionary.get(responseData.error) || 'Error');
      }
    }).catch(err => {
      console.error('Fetch error:', err);
      setErrorMessage('Fetch error');
      throw new Error(err);
    });
  };
  useEffect(() => {
    sendForm();
  }, []);
  useEffect(() => {
    tealiumClickFunc(tealiumMergeClickData(analytics['ViewScriptPageAnalytics'], params), '');
  }, []);
  useEffect(() => {
    replacePlaceholders();
  }, [mainText]);
  const sendAnalytics = btnLabel => {
    tealiumClickFunc(tealiumMergeClickData(analytics['CtaButtonAnalytics'], params), btnLabel);
  };
  const handleThankYouGenerateButton = () => {
    resetData();
    setCurrentStep(0);
    if (generateScriptLink) {
      hideModal();
    } else {
      removeFromLocalStorage();
    }
  };
  const handleThankYouBackToStoryButton = () => {
    resetData();
    setCurrentStep(0);
    hideModal();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "imageAndTitleWrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "titleImage"
  }, iconCode ? /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: iconCode
    }
  }) : /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 992px)",
    srcSet: imageIcon
  }), /*#__PURE__*/React.createElement("img", {
    src: imageIcon,
    alt: imageIconAlt,
    title: imageIconAlt
  }))), /*#__PURE__*/React.createElement("div", {
    className: "textWrapper"
  }, /*#__PURE__*/React.createElement("p", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "description"
  }, description))), /*#__PURE__*/React.createElement("div", {
    className: "thankYouMessageWrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "thankYouTitleDescription"
  }, /*#__PURE__*/React.createElement("p", {
    className: "thankYouTitle"
  }, mainTitle), /*#__PURE__*/React.createElement(RichText, {
    className: "thankYouDescription",
    tag: "p",
    field: mainTextReplaced
  })), /*#__PURE__*/React.createElement("div", {
    className: "absoluteImages"
  }, mainSecondImage ? /*#__PURE__*/React.createElement("div", {
    className: "thankYouSecondImage"
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 992px)",
    srcSet: mainSecondImage
  }), /*#__PURE__*/React.createElement("img", {
    src: mainSecondImage,
    alt: mainSecondImageAlt,
    title: mainSecondImageAlt
  }))) : null, mainFirstImage ? /*#__PURE__*/React.createElement("div", {
    className: "thankYouFirstImage"
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 992px)",
    srcSet: mainFirstImage
  }), /*#__PURE__*/React.createElement("img", {
    src: mainFirstImage,
    alt: mainFirstImageAlt,
    title: mainFirstImageAlt
  }))) : null)), /*#__PURE__*/React.createElement("div", {
    className: "buttonGroups"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    href: generateScriptLink,
    onClick: () => {
      handleThankYouGenerateButton();
      sendAnalytics(thankYouGenerateScriptLabel);
    },
    className: "btn btn-secondary"
  }, thankYouGenerateScriptLabel), /*#__PURE__*/React.createElement(RouterLink, {
    href: backToStoryLink,
    onClick: () => {
      handleThankYouBackToStoryButton();
      sendAnalytics(thankYouBackToStoryLabel);
    },
    className: "btn btn-secondary"
  }, thankYouBackToStoryLabel)), /*#__PURE__*/React.createElement("div", {
    className: "placeholder-wrapper"
  }, /*#__PURE__*/React.createElement(Placeholder, {
    name: "video-script-generator",
    rendering: rendering
  })), /*#__PURE__*/React.createElement("div", {
    className: "error-text"
  }, errorMessage), /*#__PURE__*/React.createElement(Recaptcha, {
    errorMessasge: recaptchaError,
    ref: recaptchaRef
  }));
};
VideoThankYouMessage.displayName = 'VideoThankYouMessage';
export { VideoThankYouMessage };
const commonStyles = "crt0e2z";
const ltrStyles = "l4asqrp";
const rtlStyles = "r11cetsi";